import { useMap } from "@vis.gl/react-google-maps";
import { useCallback, useEffect } from "react";
import { useNitroStore } from "../../../store/Store";
import { useIsMobile } from "../../../hooks/useIsMobile";

const MapNavigation = () => {
  const map = useMap();
  const isTablet = useIsMobile(1334);

  const [
    panToBounds,
    clearPanToBounds,
    panToCoordinates,
    setPanToCoordinates,
    showInsightsPanel,
  ] = useNitroStore((states) => [
      states.panToBounds,
      states.clearPanToBounds,
      states.panToCoordinates,
      states.setPanToCoordinates,
      states.showInsightsPanel,
    ]);

  const panToCoordinatesAction = useCallback(() => {
    if (!map) return;
    if (panToCoordinates) {
      if (!panToCoordinates.lat || !panToCoordinates.lng) return;

      map.setZoom(panToCoordinates.zoom ?? 10);

      map.setCenter({
        lat: panToCoordinates.lat,
        lng: panToCoordinates.lng,
      });

      setPanToCoordinates(undefined);
    }
  }, [map, panToCoordinates, setPanToCoordinates]);

  useEffect(() => {
    if (!map) return;

    if (panToCoordinates) {
      // Don't override an active Location Overview zoom with a default pan.
      if (showInsightsPanel) {
        setPanToCoordinates(undefined);
        return;
      }
      console.info("Pan to coordinates", { coordinates: panToCoordinates });
      panToCoordinatesAction();
    }
  }, [map, panToCoordinates, panToCoordinatesAction, showInsightsPanel, setPanToCoordinates]);

  useEffect(() => {
    if (!map) return;
    if (panToBounds) {
      // A pending fitBounds from initial search can override first Location Overview zoom.
      // When Insights is open, keep the map focused on the selected overview location.
      if (showInsightsPanel) {
        clearPanToBounds();
        return;
      }

      console.info("Pan to bounds", { panToBounds });
      map.fitBounds(panToBounds, 40);
      const zoom = map?.getZoom();
      const maxZoom = isTablet ? 6 : 12;
      if (zoom && zoom > maxZoom) {
        map?.setZoom(maxZoom);
      }
      clearPanToBounds();
    }
  }, [panToBounds, map, clearPanToBounds, isTablet, showInsightsPanel]);

  return null;
};

export default MapNavigation;
